import { createContext } from 'react';
import { ThumbnailProps } from 'src/modules/materials/components/Thumbnail';
import { SearchFilters, SearchItemsToQuery } from 'src/services/search';

export type ShowcaseContextValue = {
  itemsToQuery: SearchItemsToQuery[];

  title?: string;
  thumbnailOptions?: Pick<
    ThumbnailProps,
    | 'showTypeLabel'
    | 'showUserActions'
    | 'showLock'
    | 'showTags'
    | 'showTitle'
    | 'previewLink'
    | 'showIcon'
  >;
  defaultFilters?: SearchFilters;
};

export const ShowcaseContext = createContext<ShowcaseContextValue>({
  itemsToQuery: ['materials', 'videos'],
});
